import protoRoot from "../proto-root";

const name = "stopLullabyRpcRequest";

function create(settings) {
  const StopLullabyRpcRequest = protoRoot.lookupType(
    "comm.StopLullabyRpcRequest"
  );

  const request = StopLullabyRpcRequest.create();

  return { payload: request, name };
}

export default {
  create,
  name
};

// message StopLullabyRpcRequest { }
